var module = angular.module('octopusApp.projects');

module.run(function(pluginRegistry) {

  pluginRegistry.registerFeature("Octopus.Features.WindowsService", function(busy, octopusRepository, $rootScope, sensitiveValue) {
    return {
      title: "Windows Service",
      description: "Creates or reconfigures a Windows Service using _sc.exe_",
      editTemplateUrl: "areas/projects/features/Octopus.Features.WindowsService_edit.html",
      priority: 8,
      editLink: function($scope, element, action) {
        $scope.isWindowsServiceStep = action.ActionType === "Octopus.WindowsService";

        $scope.account = {
          bound: {},
          passwordReset: sensitiveValue.getResetValue($scope.action.Properties["Octopus.Action.WindowsService.CustomAccountPassword"])
        };
      },
      enable: function(action, step) {
        action.Properties["Octopus.Action.WindowsService.CreateOrUpdateService"] = "True";
        action.Properties["Octopus.Action.WindowsService.ServiceAccount"] = "LocalSystem";
        action.Properties["Octopus.Action.WindowsService.StartMode"] = "auto";
      },
      preSave: function(action, step) {
        if(action.Properties["Octopus.Action.WindowsService.ServiceAccount"] !== "_CUSTOM" && !$rootScope.isBound(action.Properties["Octopus.Action.WindowsService.ServiceAccount"])) {
          action.Properties["Octopus.Action.WindowsService.CustomAccountName"] = null;
          action.Properties["Octopus.Action.WindowsService.CustomAccountPassword"]  = null;
        }
      },
      validate: function(action, step, errors) {
        if (!action.Properties["Octopus.Action.WindowsService.ServiceName"]) {
          errors.push("Please enter a service name for the Windows Service.");
        }
        if (!action.Properties["Octopus.Action.WindowsService.ExecutablePath"]) {
          errors.push("Please enter an executable path for this Windows Service.");
        }
      },
      disable: function(action, step) {
          Object.keys(action.Properties).filter(function(name) {
              return name.indexOf("Octopus.Action.WindowsService.") === 0;
          }).forEach(function(name){
              delete action.Properties[name];
          });
      }
    };
  });
});




//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/features/Octopus.Features.WindowsService.js
// module id = 565
// module chunks = 1